import React from 'react';
import TeamRedCards from './TeamRedCards';
import {
  getMatchEventDisplay,
  getMatchEventsForSide,
  hasMatchEventTimeline
} from '../utils/matchEvents';
import './MatchTeamEvents.css';

/**
 * Per-team goal / card / penalty timeline for live and finished matches.
 * Falls back to red-card count badges when only aggregate counts exist.
 *
 * @param {{ game: Record<string, unknown>, side: 'home' | 'away' }} props
 */
export default function MatchTeamEvents({ game, side }) {
  const events = getMatchEventsForSide(game, side);

  if (events.length > 0) {
    return (
      <ul className={`match-team-events match-team-events--${side}`} aria-label={`${side} match events`}>
        {events.map((event, index) => {
          const { icon, label } = getMatchEventDisplay(event);
          const key = `${event.kind}-${event.minute}-${event.player}-${index}`;
          return (
            <li key={key} className={`match-team-event match-team-event--${event.kind}`} title={label}>
              {icon ? (
                <img src={icon} alt="" className="match-team-event__icon" aria-hidden="true" />
              ) : null}
              <span className="match-team-event__label">{label}</span>
            </li>
          );
        })}
      </ul>
    );
  }

  if (!hasMatchEventTimeline(game)) {
    const countKey = side === 'home' ? 'redCardsHome' : 'redCardsAway';
    const count = Math.max(0, Number(game?.[countKey] ?? (side === 'home' ? game?.rch : game?.rca)) || 0);
    if (count > 0) {
      return <TeamRedCards count={count} side={side} />;
    }
  }

  return null;
}
